/**
 * Direct (pay.js) Google Pay integration constants — used by the Stripe
 * `checkout_stripe_direct_google_pay` flow. See `GooglePayDirectStripeForm`.
 */

export const DIRECT_GOOGLE_PAY_API_VERSION = 2;
export const DIRECT_GOOGLE_PAY_API_VERSION_MINOR = 0;

export const DIRECT_GOOGLE_PAY_ALLOWED_AUTH_METHODS = ['PAN_ONLY', 'CRYPTOGRAM_3DS'] as const;
export const DIRECT_GOOGLE_PAY_ALLOWED_CARD_NETWORKS = ['AMEX', 'DISCOVER', 'JCB', 'MASTERCARD', 'VISA'] as const;

/**
 * Stripe gateway tokenization API version for Google Pay's
 * `tokenizationSpecification` — the value Google's official Stripe example
 * pins (https://developers.google.com/pay/api/web/guides/tutorial).
 */
export const DIRECT_GOOGLE_PAY_STRIPE_API_VERSION = '2018-10-31';

/**
 * Appcharge Limited's Google Pay & Wallet Console merchant registration.
 * Used only when the routed payment method carries no `paymentMethodConfig`
 * / `publicConfig` merchant info (the BE currently only populates it for
 * Adyen-routed Google Pay). The ID is public by design — Google includes it
 * in every buyflow URL — but the registration must list the checkout domain
 * for PRODUCTION approval to succeed.
 */
export const DIRECT_GOOGLE_PAY_FALLBACK_MERCHANT_INFO = {
  merchantId: 'BCR2DN7T5G22P23U',
  merchantName: 'Appcharge',
} as const;
